export class NotificationFeedItem {
  category: string;
  message: string;
  description: string;
  date: Date;
  isSeen: boolean | null;
  notificationId: number | null;
  addendumId: number | null;
  standardId: number | null;
  standardTypeId: number | null;
  notifiedUser: string | null;
  notifiedUserRole: string | null;

  get avatarLetters() {
    if (!this.notifiedUser) {
      return "N";
    }
    let pieces = this.notifiedUser.split(" ");
    if (pieces.length > 1) {
      return (
        pieces[0].substring(0, 1).toUpperCase() +
        pieces[1].substring(0, 1).toUpperCase()
      );
    }
    return this.notifiedUser.substring(0, 1).toUpperCase();
  }

  constructor(obj?: NotificationFeedItem) {
    if (obj) {
      this.category = obj.category;
      this.message = obj.message;
      this.description = obj.description;
      this.date = obj.date ? new Date(obj.date) : null;
      this.isSeen = obj.isSeen;
      this.notificationId = obj.notificationId;
      this.addendumId = obj.addendumId;
      this.standardId = obj.standardId;
      this.standardTypeId = obj.standardTypeId;
      this.notifiedUser = obj.notifiedUser;
      this.notifiedUserRole = obj.notifiedUserRole;
    }
  }
}
